import { Component } from '@angular/core';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { Router } from '@angular/router'; // Importa el Router para redirigir al usuario
import {CONSTANTES} from '../../../../shared/constanst/url-scrolls-header';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

  errorMessage: string = '';
  rutaImagen: string = CONSTANTES.LOGO_BLANCO;
  loginForm: FormGroup;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  login() {
    const request = { 
      username: this.loginForm.get('username').value,
      password: this.loginForm.get('password').value 
    };

    this.authenticationService.login(request).subscribe(response => {
      console.log(response);
      this.router.navigate(['/socios-menu-principal']);
    }, error => {
      console.error('Error al iniciar sesión:', error);
      this.errorMessage = 'Credenciales incorrectas';
    });
  }

  verificarAutenticacion() {
    this.authenticationService.verificarAutenticacion().subscribe(response => {
      console.log(response);  // Aquí podrías manejar la respuesta, mostrando un mensaje o redirigiendo al usuario
    }, error => {
      console.error("Usuario no autenticado", error);
    });
  }
  
}